export const FOLDER_PATHS = {
    BSS_AADHAR_CARDS: 'bssAadharCards',
    BSS_PAN_CARDS: 'bssPanCards',
    BSS_OTHER_DOCS: 'bssotherDocs',
    BSS_SIGNATURES: 'bssSignature',
    IDENTITY_VERIFICATION_ID_PROOFS:"identityVerificationIdProofs",
    IDENTITY_VERIFICATION_LEGAL_PHOTOS:"identityVerificationLegalPhotos",
    IDENTITY_VERIFICATION_MARKSHEETS:"identityVerificationMarksheets",
    NOC_DOCUMENTS: "nocDocuments",
} as const;


export const FILE_NAME = {
    AADHAR_CARD_ANME: 'myBssAadharCard',
    PAN_CARD_ANME: 'myBssPanCard',
    OTHER_DOC: 'myBssOtherDoc',
    SIGNATURES: 'myBssSignatures',
    ID_PROOF:"myIdentityVerificationIdProof",
    LEGAL_PHOTO:"myIdentityVerificationLegalPhoto",
    MARKSHEETS:"myIdentityVerificationMarksheets",
    NOC_DOCUMENT: "myNocDocument",
} as const;